//js code packages
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

//general functions
import * as JSFUNC from '../Library/JSFUNC.js';
import * as LibraryReact from '../Library/LibraryReact.js';


//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
//SVG Shapes/Containers
//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export const Parallelogram = inject("UserMobx")(observer(
class Parallelogram extends Component { //props: p_widthEm, p_heightEm, p_slantWidthRatioToHeightDecimal, p_borderWidthEm, p_borderColor, p_bgColor, p_hoverText, children
  render() {
    const p_widthEm = this.props.p_widthEm;
    const p_heightEm = this.props.p_heightEm;
    const p_slantWidthRatioToHeightDecimal = this.props.p_slantWidthRatioToHeightDecimal;
    const p_borderWidthEm = this.props.p_borderWidthEm;
    const p_borderColor = this.props.p_borderColor;
    const p_bgColor = this.props.p_bgColor;
    const p_hoverText = this.props.p_hoverText;

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    var widthPx = 200;
    var heightPx = 50;
    var slantWidthPx = 25;
    if(JSFUNC.is_number_not_nan_gte_0(p_widthEm) && JSFUNC.is_number_not_nan_gte_0(p_heightEm) && JSFUNC.is_number_not_nan_gte_0(p_slantWidthRatioToHeightDecimal)) {
      widthPx = (p_widthEm * c_userFontSizePx);
      heightPx = (p_heightEm * c_userFontSizePx);
      slantWidthPx = (p_slantWidthRatioToHeightDecimal * heightPx);
    }

    var borderWidthPx = 0;
    var borderWidthOrUndefined = undefined;
    if(JSFUNC.is_number_not_nan_gte_0(p_borderWidthEm)) {
      borderWidthPx = (p_borderWidthEm * c_userFontSizePx);
      borderWidthOrUndefined = borderWidthPx + "px";
    }

    const xl = borderWidthPx;
    const xr = (widthPx - Math.ceil(borderWidthPx / 2));
    const yt = borderWidthPx;
    const yb = (heightPx - Math.ceil(borderWidthPx / 2));
    const xs1 = ((slantWidthPx / widthPx) * widthPx);
    const xs2 = (widthPx - xs1);

    const borderHashColordOrUndefined = ((p_borderColor !== undefined) ? ("#" + p_borderColor) : (undefined));
    const backgroundOrUndefined = ((p_bgColor !== undefined) ? ("#" + p_bgColor) : (undefined));

    return(
      <div className="positionRelative flex11a" style={{width:widthPx + "px", height:heightPx + "px"}} title={p_hoverText}>
        <div className="positionAbsolute" style={{width:widthPx + "px", height:heightPx + "px"}}>
          <svg style={{width:"100%", height:"100%"}}>
            <polygon points={xl + "," + yb + " " + xs1 + "," + yt + " " + xr + "," + yt + " " + xs2 + "," + yb + " " + xl + "," + yb} style={{strokeWidth:borderWidthOrUndefined, stroke:borderHashColordOrUndefined, fill:backgroundOrUndefined}} />
          </svg>
        </div>
        <div className="positionAbsolute displayFlexRow" style={{width:widthPx + "px", height:heightPx + "px"}}>
          <div className="flex00a" style={{flexBasis:slantWidthPx + "px"}} />
          <div className="flex11a displayFlexColumn">
            {this.props.children}
          </div>
          <div className="flex00a" style={{flexBasis:slantWidthPx + "px"}} />
        </div>
      </div>
    );
  }
}));



//--------------------------------------------------------------------------------------------------------------------------------
//SVG Pictures
//--------------------------------------------------------------------------------------------------------------------------------
export const SvgEditPencil = inject("UserMobx")(observer(
class SvgEditPencil extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = Math.round(p_sizeEm * c_userFontSizePx);
    const hashColor = "#" + p_color;

    const xyCoords0to100ArrayOfArrays1 = [[10,86],[11,74],[24,86]];
    const polygonPointsString1 = JSFUNC.svg_polygon_points_string_from_xy_coords_0to100_array_of_arrays(xyCoords0to100ArrayOfArrays1, sizePx);

    const xyCoords0to100ArrayOfArrays2 = [[13,65],[58,20],[75,38],[33,83]];
    const polygonPointsString2 = JSFUNC.svg_polygon_points_string_from_xy_coords_0to100_array_of_arrays(xyCoords0to100ArrayOfArrays2, sizePx);

    const xyCoords0to100ArrayOfArrays3 = [[63,16],[68,10],[75,9],[84,13],[88,19],[88,27],[81,34]];
    const polygonPointsString3 = JSFUNC.svg_polygon_points_string_from_xy_coords_0to100_array_of_arrays(xyCoords0to100ArrayOfArrays3, sizePx);

    return(
      <svg height={sizePx + "px"} width={sizePx + "px"}>
        <polygon points={polygonPointsString1} style={{fill:hashColor}} />
        <polygon points={polygonPointsString2} style={{fill:hashColor}} />
        <polygon points={polygonPointsString3} style={{fill:hashColor}} />
      </svg>
    );
  }
}));


export const SvgLaunch = inject("UserMobx")(observer(
class SvgLaunch extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 1);
    const p_color = JSFUNC.prop_value(this.props.p_color, "333333");

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;
    const sizePx = Math.round(p_sizeEm * c_userFontSizePx);

    return(
      <svg width={sizePx + "px"} height={sizePx + "px"} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42 9.3-9.29H14V3z" fill={"#" + p_color} />
        <path d="M19 19H5V5h6V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-6h-2v6z" fill={"#" + p_color} />
      </svg>
    );
  }
}));

export const SvgVertical3Dots = inject("UserMobx")(observer(
class SvgVertical3Dots extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 1);
    const p_color = JSFUNC.prop_value(this.props.p_color, "333333");

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = Math.round(p_sizeEm * c_userFontSizePx);
    const hashColor = "#" + p_color;

    const rp = 11;

    const x = "50%";
    const y1p = rp;
    const y2p = 50;
    const y3p = (100 - y1p);

    const r = rp + "%";

    const heightPx = sizePx;
    const widthPx = Math.round(sizePx * ((rp * 2) / 100));

    return(
      <svg width={widthPx} height={heightPx}>
        <circle cx={x} cy={y1p + "%"} r={r} fill={hashColor} />
        <circle cx={x} cy={y2p + "%"} r={r} fill={hashColor} />
        <circle cx={x} cy={y3p + "%"} r={r} fill={hashColor} />
      </svg>
    );
  }
}));

export const SvgDraggable4Dots = inject("UserMobx")(observer(
class SvgDraggable4Dots extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 1);
    const p_color = JSFUNC.prop_value(this.props.p_color, "333333");

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = Math.round(p_sizeEm * c_userFontSizePx);
    const hashColor = "#" + p_color;

    const x1 = "25%";
    const x2 = "75%";
    const y1 = "25%";
    const y2 = "75%";

    const r = "10%";

    return(
      <svg width={sizePx} height={sizePx}>
        <circle cx={x1} cy={y1} r={r} fill={hashColor} />
        <circle cx={x1} cy={y2} r={r} fill={hashColor} />
        <circle cx={x2} cy={y1} r={r} fill={hashColor} />
        <circle cx={x2} cy={y2} r={r} fill={hashColor} />
      </svg>
    );
  }
}));

export const SvgDraggable8Dots = inject("UserMobx")(observer(
class SvgDraggable8Dots extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 1);
    const p_color = JSFUNC.prop_value(this.props.p_color, "336666");

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const relativeSize = p_sizeEm * (c_userFontSizePx / 12);
    const svgWidth = (relativeSize * 0.9) + "em";
    const svgHeight = (relativeSize * 2) + "em";
    const hashColor = "#" + p_color;

    const y1 = ((0.25 / 2) * 100) + "%";
    const y2 = ((0.75 / 2) * 100) + "%";
    const y3 = ((1.25 / 2) * 100) + "%";
    const y4 = ((1.75 / 2) * 100) + "%";
    const x1 = "25%";
    const x2 = "75%";
    const r = (relativeSize * 0.15) + "em";

    return(
      <svg width={svgWidth} height={svgHeight}>
        <circle cx={x1} cy={y1} r={r} fill={hashColor} />
        <circle cx={x1} cy={y2} r={r} fill={hashColor} />
        <circle cx={x1} cy={y3} r={r} fill={hashColor} />
        <circle cx={x1} cy={y4} r={r} fill={hashColor} />
        <circle cx={x2} cy={y1} r={r} fill={hashColor} />
        <circle cx={x2} cy={y2} r={r} fill={hashColor} />
        <circle cx={x2} cy={y3} r={r} fill={hashColor} />
        <circle cx={x2} cy={y4} r={r} fill={hashColor} />
      </svg>
    );
  }
}));



export const SvgUpDownCarat = inject("UserMobx")(observer(
class SvgUpDownCarat extends Component { //p_isDownTF, p_sizeEm, p_color
  render() {
    const p_isDownTF = JSFUNC.prop_value(this.props.p_isDownTF, false);
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 1);
    const p_color = JSFUNC.prop_value(this.props.p_color, "666666");

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const hashColor = "#" + p_color;

    const widthPx = Math.round(sizePx);
    const heightPx = Math.round(0.45 * widthPx);

    const xStartPx = Math.round(0.1 * widthPx);
    const xHalfPx = Math.round(0.5 * widthPx);
    const xFinishPx = Math.round(0.9 * widthPx);

    var yStartPx = 0;
    var yFinishPx = 0;
    if(p_isDownTF) {
      yStartPx = Math.round(0.1 * heightPx);
      yFinishPx = Math.round(0.9 * heightPx);
    }
    else {
      yStartPx = Math.round(0.9 * heightPx);
      yFinishPx = Math.round(0.1 * heightPx);
    }

    var lineWidth = Math.max(1, Math.round(widthPx / 10));

    return(
      <svg height={heightPx} width={widthPx}>
        <line x1={xStartPx} y1={yStartPx} x2={xHalfPx} y2={yFinishPx} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:"round"}} />
        <line x1={xHalfPx} y1={yFinishPx} x2={xFinishPx} y2={yStartPx} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:"round"}} />
      </svg>
    );
  }
}));


export const SvgLeftRightCarat = inject("UserMobx")(observer(
class SvgLeftRightCarat extends Component { //p_leftFalseRightTrue, p_sizeEm, p_color
  render() {
    const p_leftFalseRightTrue = this.props.p_leftFalseRightTrue;
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 1);
    const p_color = JSFUNC.prop_value(this.props.p_color, "666666");

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const hashColor = "#" + p_color;

    const heightPx = Math.round(sizePx);
    const widthPx = Math.round(0.45 * heightPx);

    var xStartPx = 0;
    var xFinishPx = 0;
    if(p_leftFalseRightTrue) {
      xStartPx = Math.round(0.9 * widthPx);
      xFinishPx = Math.round(0.1 * widthPx);
    }
    else {
      xStartPx = Math.round(0.1 * widthPx);
      xFinishPx = Math.round(0.9 * widthPx);
    }

    var yStartPx = Math.round(0.1 * heightPx);
    var yHalfPx = Math.round(0.5 * heightPx);
    var yFinishPx = Math.round(0.9 * heightPx);

    var lineWidth = Math.round(widthPx / 10);

    return(
      <svg height={heightPx} width={widthPx}>
        <line x1={xStartPx} y1={yHalfPx} x2={xFinishPx} y2={yStartPx} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:"round"}} />
        <line x1={xStartPx} y1={yHalfPx} x2={xFinishPx} y2={yFinishPx} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:"round"}} />
      </svg>
    );
  }
}));


export const SvgStretchIconLrCaratsBars = inject("UserMobx")(observer(
class SvgStretchIconLrCaratsBars extends Component { //p_sizeEm, p_color
  render() {
    //creates "<||>" icon
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 1);
    const p_color = JSFUNC.prop_value(this.props.p_color, "666666");

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const hashColor = "#" + p_color;

    const heightPx = Math.round(sizePx * 0.9);
    const widthPx = sizePx;

    const leftCaratTopX0To1 = 0.25;
    const leftCaratTopY0To1 = 0.3;
    const leftCaratMidX0To1 = 0.05;
    const leftCaratMidY0To1 = 0.5;
    const leftBarTopX0To1 = 0.41;
    const leftBarTopY0To1 = 0.05;

    const leftCaratTopX = Math.round(leftCaratTopX0To1 * widthPx);
    const leftCaratTopY = Math.round(leftCaratTopY0To1 * heightPx);
    const leftCaratMidX = Math.round(leftCaratMidX0To1 * widthPx);
    const leftCaratMidY = Math.round(leftCaratMidY0To1 * heightPx);
    const leftCaratBottomX = Math.round(leftCaratTopX0To1 * widthPx);
    const leftCaratBottomY = Math.round((1 - leftCaratTopY0To1) * heightPx);

    const leftBarTopX = Math.round(leftBarTopX0To1 * widthPx);
    const leftBarTopY = Math.round(leftBarTopY0To1 * heightPx);
    const leftBarBottomX = leftBarTopX;
    const leftBarBottomY = Math.round((1 - leftBarTopY0To1) * heightPx);

    const rightBarTopX = Math.round((1 - leftBarTopX0To1) * widthPx);
    const rightBarTopY = leftBarTopY;
    const rightBarBottomX = rightBarTopX;
    const rightBarBottomY = Math.round((1 - leftBarTopY0To1) * heightPx);

    const rightCaratTopX = Math.round((1 - leftCaratTopX0To1) * widthPx);
    const rightCaratTopY = leftCaratTopY;
    const rightCaratMidX = Math.round((1 - leftCaratMidX0To1) * widthPx);
    const rightCaratMidY = leftCaratMidY;
    const rightCaratBottomX = Math.round((1 - leftCaratTopX0To1) * widthPx);
    const rightCaratBottomY = leftCaratBottomY;

    var lineWidth = (sizePx / 15);

    return(
      <svg height={heightPx} width={widthPx}>
        <line x1={leftCaratTopX} y1={leftCaratTopY} x2={leftCaratMidX} y2={leftCaratMidY} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:"round"}} />
        <line x1={leftCaratMidX} y1={leftCaratMidY} x2={leftCaratBottomX} y2={leftCaratBottomY} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:"round"}} />
        <line x1={leftBarTopX} y1={leftBarTopY} x2={leftBarBottomX} y2={leftBarBottomY} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:"round"}} />
        <line x1={rightBarTopX} y1={rightBarTopY} x2={rightBarBottomX} y2={rightBarBottomY} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:"round"}} />
        <line x1={rightCaratTopX} y1={rightCaratTopY} x2={rightCaratMidX} y2={rightCaratMidY} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:"round"}} />
        <line x1={rightCaratMidX} y1={rightCaratMidY} x2={rightCaratBottomX} y2={rightCaratBottomY} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:"round"}} />
      </svg>
    );
  }
}));


export const SvgFunnelHorizLines = inject("UserMobx")(observer(
class SvgFunnelHorizLines extends Component { //p_sizeEm, p_color
  render() { //creates funnel icon from 4 horizontal lines
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 1);
    const p_color = JSFUNC.prop_value(this.props.p_color, "666666");

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const hashColor = "#" + p_color;

    const heightPx = sizePx;
    const widthPx = sizePx;

    const linesXLeft0To1Array = [0.1, 0.25, 0.35, 0.4, 0.4];
    const linesY0To1Array = [0.1, 0.3, 0.5, 0.7, 0.9];
    //const linesXLeft0To1Array = [0.1, 0.2, 0.3, 0.4];
    //const linesY0To1Array = [0.15, 0.35, 0.65, 0.85];
    //const linesXLeft0To1Array = [0.05, 0.25, 0.4];
    //const linesY0To1Array = [0.1, 0.5, 0.9];
    
    var linesArrayOfObjs = [];
    for(let i = 0; i < linesXLeft0To1Array.length; i++) {
      linesArrayOfObjs.push({
        leftX: Math.round(linesXLeft0To1Array[i] * widthPx),
        rightX: Math.round((1 - linesXLeft0To1Array[i]) * widthPx),
        y: Math.round(linesY0To1Array[i] * heightPx)
      });
    }

    var lineWidth = (sizePx / 9);

    return(
      <svg height={heightPx} width={widthPx}>
        {linesArrayOfObjs.map((lineObj, index) => (
          <line key={index} x1={lineObj.leftX} y1={lineObj.y} x2={lineObj.rightX} y2={lineObj.y} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:"round"}} />
        ))}
      </svg>
    );
  }
}));


export const SvgFunnelSolid = inject("UserMobx")(observer(
class SvgFunnelSolid extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 1);
    const p_color = JSFUNC.prop_value(this.props.p_color, "666666");

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const hashColor = "#" + p_color;

    const heightPx = sizePx;
    const widthPx = sizePx;

    //"14,18 86,18 58,53 58,79 42,88 42,53"
    const xyCoords0to100ArrayOfArrays1 = [
      [14,18],[86,18],[58,53],[58,79],[42,88],[42,53]
    ];
    const polygonPointsString1 = JSFUNC.svg_polygon_points_string_from_xy_coords_0to100_array_of_arrays(xyCoords0to100ArrayOfArrays1, sizePx);

    return(
      <svg height={heightPx} width={widthPx}>
        <polygon points={polygonPointsString1} style={{fill:hashColor}} />
      </svg>
    );
  }
}));


export const SvgFile = inject("UserMobx")(observer(
class SvgFile extends Component { //p_fileLoc, p_xmlType, p_sizeEm, p_color, p_innerColor, p_thinEdgeTF, p_thickLinesTF
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 1);
    const p_fileLoc = this.props.p_fileLoc;
    const p_xmlType = this.props.p_xmlType;
    const p_thinEdgeTF = JSFUNC.prop_value(this.props.p_thinEdgeTF, false);
    const p_thickLinesTF = JSFUNC.prop_value(this.props.p_thickLinesTF, false);

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);

    const heightPx = Math.round(sizePx);
    const widthPx = Math.round(0.75 * heightPx);

    const svgHeight = heightPx + "px";
    const svgWidth = widthPx + "px";

    const xStartPx = Math.round(0.1 * widthPx);
    const xTrianglePx = Math.round(0.63 * widthPx);
    const xFinishPx = Math.round(0.9 * widthPx);

    const yStartPx = Math.round(0.1 * heightPx);
    const yTrianglePx = Math.round(0.31 * heightPx);
    const yFinishPx = Math.round(0.9 * heightPx);

    var lineWidth = "3%";
    if(p_thinEdgeTF) {
      lineWidth = "1px";
    }
    else if(p_thickLinesTF) {
      lineWidth = "7%";
    }

    var contentWidth = "3%";
    if(p_thickLinesTF) {
      contentWidth = "7%";
    }

    const strokeLinecap = "round"

    var color = "bbbbbb";
    var contentColor = "bbbbbb";
    if(this.props.p_color !== undefined) {
      color = this.props.p_color;
      if(this.props.p_innerColor !== undefined) {
        contentColor = this.props.p_innerColor;
      }
      else {
        contentColor = this.props.p_color;
      }
    }

    const customColorsObj = JSFUNC.custom_colors_obj();

    var solidBgFileLabel = undefined;
    var xmlLabelTF = false;
    if(JSFUNC.is_string(p_fileLoc)) {
      const fileLocFilePartsObj = JSFUNC.file_parts_obj(p_fileLoc);
      if(fileLocFilePartsObj.fileExt === "xml") {
        xmlLabelTF = true;
        if(p_xmlType === "word") { //xml word
          color = customColorsObj.wordBlue;
        }
        else if(p_xmlType === "excel") { //xml excel
          color = customColorsObj.excelGreen;
        }
        else if(p_xmlType === "ppt") { //xml ppt
          color = customColorsObj.pptOrange;
        }
        else { //xml
          color = "777";
        }
      }
      else if(JSFUNC.in_array(fileLocFilePartsObj.fileExt, ["doc", "docx", "odt"])) {
        solidBgFileLabel = "doc";
        color = customColorsObj.wordBlue;
      }
      else if(JSFUNC.in_array(fileLocFilePartsObj.fileExt, ["xls", "xlsx", "ods"])) {
        solidBgFileLabel = "xls";
        color = customColorsObj.excelGreen;
      }
      else if(JSFUNC.in_array(fileLocFilePartsObj.fileExt, ["ppt", "pptx", "odp"])) {
        solidBgFileLabel = "ppt";
        color = customColorsObj.pptOrange;
      }
      else if(fileLocFilePartsObj.fileExt === "pdf") {
        solidBgFileLabel = "pdf";
        color = "bd2326";
      }
      else { //blank white file with gray edges and gray horiz lines

      }
      contentColor = color;
    }

    const xStart = xStartPx + "px";
    const xTriangle = xTrianglePx + "px";
    const xFinish = xFinishPx + "px";
    const yStart = yStartPx + "px"; //7px
    const yTriangle = yTrianglePx + "px"; //20px
    const yFinish = yFinishPx + "px"; //59px

    color = "#" + color;
    contentColor = "#" + contentColor;

    if(solidBgFileLabel !== undefined) {
      return(
        <svg height={svgHeight} width={svgWidth}>
          <rect x={xStart} y={yStart} width={(xTrianglePx-xStartPx) + "px"} height={(yFinishPx-yStartPx) + "px"} style={{fill:color}} />
          <rect x={xStart} y={yTriangle} width={(xFinishPx-xStartPx) + "px"} height={(yFinishPx-yTrianglePx) + "px"} style={{fill:color}} />

          <line x1={xTriangle} y1={yStart} x2={xFinish} y2={yTriangle} style={{stroke:color, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />

          <text x="17%" y="68%" fill="#ffffff" style={{fontSize:Math.round(0.29 * sizePx) + "px"}}>{solidBgFileLabel}</text>
        </svg>
      );
    }

    return(
      <svg height={svgHeight} width={svgWidth}>
        <line x1={xStart} y1={yStart} x2={xTriangle} y2={yStart} style={{stroke:color, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xTriangle} y1={yStart} x2={xFinish} y2={yTriangle} style={{stroke:color, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xFinish} y1={yTriangle} x2={xFinish} y2={yFinish} style={{stroke:color, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xFinish} y1={yFinish} x2={xStart} y2={yFinish} style={{stroke:color, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xStart} y1={yFinish} x2={xStart} y2={yStart} style={{stroke:color, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xTriangle} y1={yStart} x2={xTriangle} y2={yTriangle} style={{stroke:color, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xTriangle} y1={yTriangle} x2={xFinish} y2={yTriangle} style={{stroke:color, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />

        <line x1="15%" y1="40%" x2="75%" y2="40%" style={{stroke:contentColor, strokeWidth:contentWidth}} />
        <line x1="15%" y1="50%" x2="75%" y2="50%" style={{stroke:contentColor, strokeWidth:contentWidth}} />
        <line x1="15%" y1="60%" x2="75%" y2="60%" style={{stroke:contentColor, strokeWidth:contentWidth}} />
        <line x1="15%" y1="70%" x2="75%" y2="70%" style={{stroke:contentColor, strokeWidth:contentWidth}} />
        <line x1="15%" y1="80%" x2="75%" y2="80%" style={{stroke:contentColor, strokeWidth:contentWidth}} />

        {(xmlLabelTF) &&
          <>
            <rect x="1%" y="36%" rx="15%" ry="40%" width="98%" height="40%" style={{fill:contentColor}} />
            <text x="10%" y="68%" fill="#ffffff" style={{fontSize:Math.round(0.29 * sizePx) + "px"}}>{"XML"}</text>
          </>
        }
      </svg>
    );
  }
}));


export const SvgFolder = inject("UserMobx")(observer(
class SvgFolder extends Component { //p_widthEm, p_heightEm, p_xStart0to100, p_xEnd0to100, p_yStart0to100, p_yEnd0to100, p_lineColor, p_plusTF
  render() {
    const p_widthEm = JSFUNC.prop_value(this.props.p_widthEm, 1);
    const p_heightEm = JSFUNC.prop_value(this.props.p_heightEm, 1);
    const p_xStart0to100 = JSFUNC.prop_value(this.props.p_xStart0to100, 0);
    const p_xEnd0to100 = JSFUNC.prop_value(this.props.p_xEnd0to100, 100);
    const p_yStart0to100 = JSFUNC.prop_value(this.props.p_yStart0to100, 0);
    const p_yEnd0to100 = JSFUNC.prop_value(this.props.p_yEnd0to100, 100);
    const p_lineColor = JSFUNC.prop_value(this.props.p_lineColor, "bbbbbb");
    const p_plusTF = JSFUNC.prop_value(this.props.p_plusTF, false);

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const widthPx = Math.round(p_widthEm * c_userFontSizePx);
    const heightPx = Math.round(p_heightEm * c_userFontSizePx);

    const lineWidth = 1;
    const strokeLinecap = "round";

    //can 'window' the SVG line positions to scale and shift the picture within the frame
    // - p_xStart0to100 = 0 and p_xEnd0to100 = 100, 3 -> "3%"
    // - p_xStart0to100 = 10 and p_xEnd0to100 = 70, 3 -> ((3 / 100) * (70-10) + 10) = "11.8%"
    var xb1 = 3;
    var xb2 = 13;
    var xb3 = 15;
    var xb4 = 39;
    var xb5 = 41;
    var xb6 = 78;
    var xf2 = 25;
    var xf4 = 97;
    var yb1 = 97;
    var yb2 = 17;
    var yb3 = 3;
    var yf2 = 33;

    if((p_xStart0to100 !== 0) || (p_xEnd0to100 !== 100)) {
      xb1 = (((xb1 / 100) * (p_xEnd0to100 - p_xStart0to100)) + p_xStart0to100);
      xb2 = (((xb2 / 100) * (p_xEnd0to100 - p_xStart0to100)) + p_xStart0to100);
      xb3 = (((xb3 / 100) * (p_xEnd0to100 - p_xStart0to100)) + p_xStart0to100);
      xb4 = (((xb4 / 100) * (p_xEnd0to100 - p_xStart0to100)) + p_xStart0to100);
      xb5 = (((xb5 / 100) * (p_xEnd0to100 - p_xStart0to100)) + p_xStart0to100);
      xb6 = (((xb6 / 100) * (p_xEnd0to100 - p_xStart0to100)) + p_xStart0to100);
      xf2 = (((xf2 / 100) * (p_xEnd0to100 - p_xStart0to100)) + p_xStart0to100);
      xf4 = (((xf4 / 100) * (p_xEnd0to100 - p_xStart0to100)) + p_xStart0to100);
    }

    if((p_yStart0to100 !== 0) || (p_yEnd0to100 !== 100)) {
      yb1 = (((yb1 / 100) * (p_yEnd0to100 - p_yStart0to100)) + p_yStart0to100);
      yb2 = (((yb2 / 100) * (p_yEnd0to100 - p_yStart0to100)) + p_yStart0to100);
      yb3 = (((yb3 / 100) * (p_yEnd0to100 - p_yStart0to100)) + p_yStart0to100);
      yf2 = (((yf2 / 100) * (p_yEnd0to100 - p_yStart0to100)) + p_yStart0to100);
    }

    xb1 = xb1 + "%";
    xb2 = xb2 + "%";
    xb3 = xb3 + "%";
    xb4 = xb4 + "%";
    xb5 = xb5 + "%";
    xb6 = xb6 + "%";
    xf2 = xf2 + "%";
    xf4 = xf4 + "%";
    yb1 = yb1 + "%";
    yb2 = yb2 + "%";
    yb3 = yb3 + "%";
    yf2 = yf2 + "%";

    return(
      <svg height={heightPx + "px"} width={widthPx + "px"}>
        <line x1={xb1} x2={xb1} y1={yb1} y2={yb2} style={{stroke:"#" + p_lineColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xb1} x2={xb2} y1={yb2} y2={yb2} style={{stroke:"#" + p_lineColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xb2} x2={xb3} y1={yb2} y2={yb3} style={{stroke:"#" + p_lineColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xb3} x2={xb4} y1={yb3} y2={yb3} style={{stroke:"#" + p_lineColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xb4} x2={xb5} y1={yb3} y2={yb2} style={{stroke:"#" + p_lineColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xb5} x2={xb6} y1={yb2} y2={yb2} style={{stroke:"#" + p_lineColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xb6} x2={xb6} y1={yb2} y2={yf2} style={{stroke:"#" + p_lineColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />

        <line x1={xb1} x2={xf2} y1={yb1} y2={yf2} style={{stroke:"#" + p_lineColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xf2} x2={xf4} y1={yf2} y2={yf2} style={{stroke:"#" + p_lineColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xf4} x2={xb6} y1={yf2} y2={yb1} style={{stroke:"#" + p_lineColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xb6} x2={xb1} y1={yb1} y2={yb1} style={{stroke:"#" + p_lineColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />

        {(p_plusTF) && 
        <>
          <LibraryReact.SvgHLine p_x1p={70} p_x2p={100} p_ycp={80} p_widthP={7} p_color="#77c" />
          <LibraryReact.SvgVLine p_y1p={65} p_y2p={95} p_xcp={85} p_widthP={7} p_color="#77c" />
        </>
      }
      </svg>
    );
  }
}));


export const SvgChain = inject("UserMobx")(observer(
class SvgChain extends Component { //p_widthEm, p_heightEm, p_xStart0to100, p_xEnd0to100, p_yStart0to100, p_yEnd0to100, p_lineWidth, p_lineColor, p_plusTF
  render() {
    const p_widthEm = JSFUNC.prop_value(this.props.p_widthEm, 1);
    const p_heightEm = JSFUNC.prop_value(this.props.p_heightEm, 1);
    const p_xStart0to100 = JSFUNC.prop_value(this.props.p_xStart0to100, 0);
    const p_xEnd0to100 = JSFUNC.prop_value(this.props.p_xEnd0to100, 100);
    const p_yStart0to100 = JSFUNC.prop_value(this.props.p_yStart0to100, 0);
    const p_yEnd0to100 = JSFUNC.prop_value(this.props.p_yEnd0to100, 100);
    const p_lineColor = JSFUNC.prop_value(this.props.p_lineColor, "bbbbbb");
    const p_lineWidth = JSFUNC.prop_value(this.props.p_lineWidth, "6%");
    const p_plusTF = JSFUNC.prop_value(this.props.p_plusTF, false);

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const widthPx = Math.round(p_widthEm * c_userFontSizePx);
    const heightPx = Math.round(p_heightEm * c_userFontSizePx);

    /*const v = JSFUNC.calculate_circle_points_xy_0to1_arrays_obj(90, 5, true, 37, 4);
    const x0to1Array = v.x0to1Array;
    const y0to1Array = v.y0to1Array;

    var xyCoords0to100ArrayOfArrays1 = [];
    for(let c = 0; c < x0to1Array.length; c++) {
      var x = (28 + Math.round(x0to1Array[c] * 23));
      var y = (50 + Math.round(y0to1Array[c] * 45));
      xyCoords0to100ArrayOfArrays1.push([x, y]);
    }

    var s = "[";
    for(let c of xyCoords0to100ArrayOfArrays1) {
      s += "[" + c[0] + "," + c[1] + "],";
    }alert(s)*/

    //left chain link
    var xyCoords0to100ArrayOfArrays1 = [
      [35,95],
      [26,95],[24,94],[22,93],[20,92],[18,91],[17,89],[15,87],[13,84],[12,82],[10,79],[9,76],[8,73],[7,69],[6,65],[6,62],[5,58],[5,54],[5,50],
      [5,46],[5,42],[6,38],[6,35],[7,31],[8,28],[9,24],[10,21],[12,18],[13,16],[15,13],[17,11],[18,9],[20,8],[22,7],[24,6],[26,5],
      [37,5],[39,6],[41,7],[43,8],[45,9],[46,11],[48,13],[50,16],[51,18],[53,21],[54,24],[55,28],[56,31],[57,35],[57,38],[56,42],[56,46],[56,50],[56,54],[56,58],[55,62],[55,65]
    ];

    //scale into desired x/y start/end coordinates within svg width/height frame
    if((p_xStart0to100 !== 0) || (p_xEnd0to100 !== 100) || (p_yStart0to100 !== 0) || (p_yEnd0to100 !== 100)) {
      for(let xyCoords0to100Array of xyCoords0to100ArrayOfArrays1) {
        xyCoords0to100Array[0] = (((xyCoords0to100Array[0] / 100) * (p_xEnd0to100 - p_xStart0to100)) + p_xStart0to100);
        xyCoords0to100Array[1] = (((xyCoords0to100Array[1] / 100) * (p_yEnd0to100 - p_yStart0to100)) + p_yStart0to100);
      }
    }

    const polygonPointsString1 = JSFUNC.svg_polygon_points_string_from_xy_coords_0to100_array_of_arrays(xyCoords0to100ArrayOfArrays1, widthPx);

    //mirror image of 2nd chain link by flipping image on x and y axis
    for(let xyCoords0to100Array of xyCoords0to100ArrayOfArrays1) {
      xyCoords0to100Array[0] = (100 - xyCoords0to100Array[0]);
      xyCoords0to100Array[1] = (100 - xyCoords0to100Array[1]);
    }
    const polygonPointsString2 = JSFUNC.svg_polygon_points_string_from_xy_coords_0to100_array_of_arrays(xyCoords0to100ArrayOfArrays1, widthPx);

    return(
      <svg height={heightPx + "px"} width={widthPx + "px"}>
        <polyline points={polygonPointsString1} style={{fill:"none", stroke:"#" + p_lineColor, strokeWidth:p_lineWidth}} />
        <polyline points={polygonPointsString2} style={{fill:"none", stroke:"#" + p_lineColor, strokeWidth:p_lineWidth}} />

        {(p_plusTF) && 
          <>
            <LibraryReact.SvgHLine p_x1p={70} p_x2p={100} p_ycp={80} p_widthP={7} p_color="#77c" />
            <LibraryReact.SvgVLine p_y1p={65} p_y2p={95} p_xcp={85} p_widthP={7} p_color="#77c" />
          </>
        }
      </svg>
    );
  }
}));


export const SvgPresentation = inject("UserMobx")(observer(
class SvgPresentation extends Component { //p_sizeEm
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 1);

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const widthPx = Math.round(sizePx);
    const heightPx = Math.round(0.70 * widthPx);

    const svgHeight = heightPx + "px";
    const svgWidth = widthPx + "px";

    const xStart = Math.round(0.1 * widthPx) + "px";
    const xTriangle = Math.round(0.75 * widthPx) + "px";
    const xFinish = Math.round(0.9 * widthPx) + "px";

    const yStart = Math.round(0.1 * heightPx) + "px";
    const yTriangle = Math.round(0.31 * heightPx) + "px";
    const yFinish = Math.round(0.9 * heightPx) + "px";

    const lineWidth = "1px";
    const strokeLinecap = "round"

    const hashColor = "#888a99";

    const contentHashColor = "#f9f9f9";
    const contentWidth = "4%";

    return(
      <svg height={svgHeight} width={svgWidth}>
        <line x1={xStart} y1={yStart} x2={xTriangle} y2={yStart} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xTriangle} y1={yStart} x2={xFinish} y2={yTriangle} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xFinish} y1={yTriangle} x2={xFinish} y2={yFinish} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xFinish} y1={yFinish} x2={xStart} y2={yFinish} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xStart} y1={yFinish} x2={xStart} y2={yStart} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xTriangle} y1={yStart} x2={xTriangle} y2={yTriangle} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />
        <line x1={xTriangle} y1={yTriangle} x2={xFinish} y2={yTriangle} style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:strokeLinecap}} />

        <circle cx="35%" cy="48%" r="22%" fill="none" style={{stroke:contentHashColor, strokeWidth:contentWidth}} />
        <line x1="60%" y1="40%" x2="85%" y2="40%" style={{stroke:contentHashColor, strokeWidth:contentWidth}} />
        <line x1="60%" y1="55%" x2="85%" y2="55%" style={{stroke:contentHashColor, strokeWidth:contentWidth}} />
        <line x1="60%" y1="70%" x2="85%" y2="70%" style={{stroke:contentHashColor, strokeWidth:contentWidth}} />
      </svg>
    );
  }
}));

export function SvgPerson(props) { //p_sizePx, p_color, p_plusTF
  const p_sizePx = Math.round(JSFUNC.prop_value(props.p_sizePx, 24));
  const p_color = JSFUNC.prop_value(props.p_color, "999999");
  const p_plusTF = JSFUNC.prop_value(props.p_plusTF, false);

  const heightPx = Math.round(p_sizePx);
  const widthPx = Math.round(p_sizePx);
  const svgHeight = heightPx + "px";
  const svgWidth = widthPx + "px";
  const hashColor = "#" + p_color;

  //shoulders
  const e1cx = Math.round(0.5 * widthPx) + "px";
  const e1cy = Math.round(1.1 * widthPx) + "px";
  const e1rx = Math.round(0.6 * widthPx) + "px";
  const e1ry = Math.round(0.5 * widthPx) + "px";

  //head
  const e2cx = Math.round(0.5 * widthPx) + "px";
  const e2cy = Math.round(0.35 * widthPx) + "px";
  const e2rx = Math.round(0.25 * widthPx) + "px";
  const e2ry = Math.round(0.3 * widthPx) + "px";

  return(
    <svg height={svgHeight} width={svgWidth}>
      <ellipse cx={e1cx} cy={e1cy} rx={e1rx} ry={e1ry} style={{fill:hashColor}} />
      <ellipse cx={e2cx} cy={e2cy} rx={e2rx} ry={e2ry} style={{fill:hashColor}} />

      {(p_plusTF) && 
        <SvgPlusBadge />
      }
    </svg>
  );
}

export function SvgCompany(props) { //p_sizePx, p_color, p_plusTF
  const p_sizePx = Math.round(JSFUNC.prop_value(props.p_sizePx, 24));
  const p_color = JSFUNC.prop_value(props.p_color, "999999");
  const p_plusTF = JSFUNC.prop_value(props.p_plusTF, false);

  const heightPx = Math.round(p_sizePx);
  const widthPx = Math.round(p_sizePx);
  const svgHeight = heightPx + "px";
  const svgWidth = widthPx + "px";
  const hashColor = "#" + p_color;

  return(
    <svg height={svgHeight} width={svgWidth}>
      <rect x="5%" y="10%" width="5%" height="90%" style={{fill:hashColor}} />
      <rect x="25%" y="10%" width="5%" height="90%" style={{fill:hashColor}} />
      <rect x="45%" y="10%" width="5%" height="90%" style={{fill:hashColor}} />
      <rect x="5%" y="80%" width="45%" height="20%" style={{fill:hashColor}} />
      <rect x="5%" y="56.6%" width="45%" height="5%" style={{fill:hashColor}} />
      <rect x="5%" y="33.3%" width="45%" height="5%" style={{fill:hashColor}} />
      <rect x="5%" y="7%" width="45%" height="8%" style={{fill:hashColor}} />

      <rect x="50%" y="50%" width="5%" height="50%" style={{fill:hashColor}} />
      <rect x="70%" y="50%" width="5%" height="50%" style={{fill:hashColor}} />
      <rect x="90%" y="50%" width="5%" height="50%" style={{fill:hashColor}} />
      <rect x="50%" y="85%" width="45%" height="15%" style={{fill:hashColor}} />
      <rect x="50%" y="67.5%" width="45%" height="5%" style={{fill:hashColor}} />
      <rect x="50%" y="47%" width="45%" height="8%" style={{fill:hashColor}} />

      {(p_plusTF) && [
        <SvgPlusBadge key="plusBadge" />
      ]}
    </svg>
  );
}

function SvgPlusBadge() {
  return(
    <>
      <circle cx="82.5%" cy="82.5%" r="16%" style={{fill:"#2d7772", stroke:"#f6f6f1", strokeWidth:"2%"}} />
      <LibraryReact.SvgHLine p_x1p={74} p_x2p={91} p_ycp={82.5} p_widthP={7} p_color="#ffffff" />
      <LibraryReact.SvgVLine p_y1p={74} p_y2p={91} p_xcp={82.5} p_widthP={7} p_color="#ffffff" />
    </>
  );
}

export const SvgSmartFunnel = inject("UserMobx")(observer(
class SvgSmartFunnel extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");
    
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const heightPx = Math.round(sizePx);
    const widthPx = Math.round(sizePx);
    const svgHeight = heightPx + "px";
    const svgWidth = widthPx + "px";
    const hashColor = "#" + p_color;

    const circle1X = 18;
    const circle1Y = 14;
    const circle2X = 43;
    const circle2Y = 35;
    const circle3X = 64;
    const circle3Y = 10;
    const circle4X = 84;
    const circle4Y = 19;
    const circleRadius = 7;
    const circleEdgeWidth = 5;

    const line1X1 = 23;
    const line1Y1 = 18;
    const line1X2 = 38;
    const line1Y2 = 31;
    const line2X1 = 46;
    const line2Y1 = 31;
    const line2X2 = 60;
    const line2Y2 = 15;
    const line3X1 = 70;
    const line3Y1 = 12;
    const line3X2 = 79;
    const line3Y2 = 17;
    const lineWidth = 8;

    const xyCoords0to100ArrayOfArrays1 = [
      [60,24],[71,25],[77,27],[84,30],[86,32],[86,44],[56,70],[56,93],[53,95],[47,96],
      [41,95],[38,93],[38,70],[7,44],[7,31],[11,28],[18,26],[24,25],[27,29],[19,31],
      [18,33],[26,36],[35,38],[47,39],[60,38],[70,36],[76,33],[75,31],[67,29],[56,28]
    ];
    const polygonPointsString1 = JSFUNC.svg_polygon_points_string_from_xy_coords_0to100_array_of_arrays(xyCoords0to100ArrayOfArrays1, sizePx);

    return(
      <svg height={svgHeight} width={svgWidth}>
        <polygon points={polygonPointsString1} style={{fill:hashColor}} />

        <circle cx={circle1X + "%"} cy={circle1Y + "%"} r={circleRadius + "%"} stroke={hashColor} strokeWidth={circleEdgeWidth + "%"} fill="transparent" />
        <circle cx={circle2X + "%"} cy={circle2Y + "%"} r={circleRadius + "%"} stroke={hashColor} strokeWidth={circleEdgeWidth + "%"} fill="transparent" />
        <circle cx={circle3X + "%"} cy={circle3Y + "%"} r={circleRadius + "%"} stroke={hashColor} strokeWidth={circleEdgeWidth + "%"} fill="transparent" />
        <circle cx={circle4X + "%"} cy={circle4Y + "%"} r={circleRadius + "%"} stroke={hashColor} strokeWidth={circleEdgeWidth + "%"} fill="transparent" />

        <line x1={line1X1 + "%"} x2={line1X2 + "%"} y1={line1Y1 + "%"} y2={line1Y2 + "%"} style={{stroke:hashColor, strokeWidth:lineWidth + "%"}} />
        <line x1={line2X1 + "%"} x2={line2X2 + "%"} y1={line2Y1 + "%"} y2={line2Y2 + "%"} style={{stroke:hashColor, strokeWidth:lineWidth + "%"}} />
        <line x1={line3X1 + "%"} x2={line3X2 + "%"} y1={line3Y1 + "%"} y2={line3Y2 + "%"} style={{stroke:hashColor, strokeWidth:lineWidth + "%"}} />
      </svg>
    );
  }
}));

export const SvgSpiralNotebookWithCheck = inject("UserMobx")(observer(
class SvgSpiralNotebookWithCheck extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");
    
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const heightPx = Math.round(sizePx);
    const widthPx = Math.round(sizePx);
    const svgHeight = heightPx + "px";
    const svgWidth = widthPx + "px";
    const hashColor = "#" + p_color;

    const x1 = 20;
    const x2 = 85;
    const yB = 95;
    const yT = 5;
    const edgeWidth = "4%";

    const spiralX1 = 13;
    const sprialX2 = 27;
    const spiralYArray = [14, 32, 50, 68, 86];
    const sprialWidth = "8%";

    const textX1 = 35;
    const textX2 = 65;
    const textYArray = [20, 30, 40];
    const textWidth = "3%";

    const checkX1 = 60;
    const checkX2 = 70;
    const checkX3 = 98;
    const checkYB = 80;
    const checkYM = 70;
    const checkYT = 40;
    const checkWidth = "6%";

    return(
      <svg height={svgHeight} width={svgWidth}>
        <line x1={x1 + "%"} x2={x1 + "%"} y1={yB + "%"} y2={yT + "%"} style={{stroke:hashColor, strokeWidth:edgeWidth}} />
        <line x1={x1 + "%"} x2={x2 + "%"} y1={yT + "%"} y2={yT + "%"} style={{stroke:hashColor, strokeWidth:edgeWidth}} />
        <line x1={x2 + "%"} x2={x2 + "%"} y1={yT + "%"} y2={yB + "%"} style={{stroke:hashColor, strokeWidth:edgeWidth}} />
        <line x1={x2 + "%"} x2={x1 + "%"} y1={yB + "%"} y2={yB + "%"} style={{stroke:hashColor, strokeWidth:edgeWidth}} />

        {spiralYArray.map((m_spiralY) =>
          <line key={"spiral" + m_spiralY} x1={spiralX1 + "%"} x2={sprialX2 + "%"} y1={m_spiralY + "%"} y2={m_spiralY + "%"} style={{stroke:hashColor, strokeWidth:sprialWidth}} />
        )}

        {textYArray.map((m_textY) =>
          <line key={"text" + m_textY} x1={textX1 + "%"} x2={textX2 + "%"} y1={m_textY + "%"} y2={m_textY + "%"} style={{stroke:hashColor, strokeWidth:textWidth}} />
        )}

        <line x1={checkX1 + "%"} x2={checkX2 + "%"} y1={checkYM + "%"} y2={checkYB + "%"} style={{stroke:hashColor, strokeWidth:checkWidth}} />
        <line x1={checkX2 + "%"} x2={checkX3 + "%"} y1={checkYB + "%"} y2={checkYT + "%"} style={{stroke:hashColor, strokeWidth:checkWidth}} />
      </svg>
    );
  }
}));

export const SvgCompanySlashPerson = inject("UserMobx")(observer(
class SvgCompanySlashPerson extends Component { //p_sizeEm, p_color, p_plusTF
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");
    
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const heightPx = Math.round(sizePx);
    const widthPx = Math.round(sizePx);
    const hashColor = "#" + p_color;

    const svgHeight = heightPx + "px";
    const svgWidth = widthPx + "px";

    const x2 = 25;
    const x1 = x2 - 20;
    const x3 = x2 + 20;
    const yTop = 5;
    const h = 50;

    const xCenter = 0.75;

    //shoulders
    const e1cx = Math.round(xCenter * widthPx) + "px";
    const e1cy = Math.round(1.05 * widthPx) + "px";
    const e1rx = Math.round(0.3 * widthPx) + "px";
    const e1ry = Math.round(0.25 * widthPx) + "px";

    //head
    const e2cx = Math.round(xCenter * widthPx) + "px";
    const e2cy = Math.round(0.7 * widthPx) + "px";
    const e2rx = Math.round(0.125 * widthPx) + "px";
    const e2ry = Math.round(0.15 * widthPx) + "px";

    return(
      <svg height={svgHeight} width={svgWidth}>
        <rect x={x1 + "%"} y={yTop + "%"} width="5%" height={h + "%"} style={{fill:hashColor}} />
        <rect x={x2 + "%"} y={yTop + "%"} width="5%" height={h + "%"} style={{fill:hashColor}} />
        <rect x={x3 + "%"} y={yTop + "%"} width="5%" height={h + "%"} style={{fill:hashColor}} />
        <rect x={x1 + "%"} y={(yTop + h - 15) + "%"} width="45%" height="20%" style={{fill:hashColor}} />
        <rect x={x1 + "%"} y={((yTop + yTop + h - 15) / 2) + "%"} width="45%" height="5%" style={{fill:hashColor}} />
        <rect x={x1 + "%"} y={(yTop - 3) + "%"} width="45%" height="8%" style={{fill:hashColor}} />

        <ellipse cx={e1cx} cy={e1cy} rx={e1rx} ry={e1ry} style={{fill:hashColor}} />
        <ellipse cx={e2cx} cy={e2cy} rx={e2rx} ry={e2ry} style={{fill:hashColor}} />

        <line x1="20%" x2="95%" y1="95%" y2="5%" style={{stroke:hashColor, strokeWidth:"2%"}} />

        {(this.props.p_plusTF) && [
          <LibraryReact.SvgHLine key="h" p_x1p={75} p_x2p={95} p_ycp={90} p_widthP={7} p_color={"#77c"} />,
          <LibraryReact.SvgVLine key="v" p_y1p={80} p_y2p={100} p_xcp={85} p_widthP={7} p_color={"#77c"} />
        ]}
      </svg>
    );
  }
}));

export const SvgCapture = inject("UserMobx")(observer(
class SvgCapture extends Component { //p_sizeEm, p_color, p_plusTF
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");
    
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const heightPx = Math.round(sizePx);
    const widthPx = Math.round(sizePx);
    const hashColor = "#" + p_color;

    const svgHeight = heightPx + "px";
    const svgWidth = widthPx + "px";

    const xS = 3; //x start of whole drawer
    const xE = 97; //x end of whole drawer
    const wH = 26; //handle width inside of drawer face
    const wHT = 3; //handle thickness for inside edge

    const yS = 31; //y start at top of drawer
    const yE = 98; //y end at bottom of drawer
    const hT = 11; //height from drawer top until top of first handle is reached
    const hH = 22; //height of the top drawer handle
    const hB = 10; //height from bottom of top drawer handle to top of 2nd handle

    const wD = (xE - xS); //width of the drawer face
    const wS = ((wD - wH) / 2); //x side width before reaching handle
    const xH1 = (xS + wS); //x start of handle
    const xH2 = (xH1 + wHT); //x start of inside handle
    const xH4 = (xE - wS); //x end of handle
    const xH3 = (xH4 - wHT); //x end of inside handle

    const hY = (yE - yS); //y height of drawer
    const yH1 = (yS + hT); //y start of handle 1 top
    const yH2 = (yH1 + wHT);
    const yH4 = (yH1 + hH);
    const yH3 = (yH4 - wHT);
    const yH5 = (yH4 + hB);
    const yH6 = (yH5 + wHT);

    const fLW = "3%"; //folder line widths
    const fLC = "round"; //folder line caps

    const f1W = 81;
    const f1H = 20;
    const f1wt = 20; //width of folder 1 tab
    const f1ht = 7; //height of folder 1 tab
    const f1xS = ((100 - f1W) / 2); //left edge of folder 1
    const f1xT = (f1xS + f1wt); //x of tab transition
    const f1xE = (100 - f1xS); //right edge of folder 1
    const f1yE = yS; //bottom of folder 1 is at top of drawer
    const f1yS = f1yE - f1H; //top of folder 1

    const f2W = 73;
    const f2H = 10;
    const f2wt = 18; //width of folder 2 tab
    const f2ht = 5; //height of folder 2 tab
    const f2xS = ((100 - f2W) / 2); //left edge of folder 2
    const f2xT = (f2xS + f2wt); //x of tab transition
    const f2xE = (100 - f2xS); //right edge of folder 2
    const f2yE = f1yS; //bottom of folder 2 is at top of folder 1
    const f2yS = f2yE - f2H; //top of folder 2

    return(
      <svg height={svgHeight} width={svgWidth}>
        <rect x={xS + "%"} y={yS + "%"} width={wS + "%"} height={hY + "%"} style={{fill:hashColor}} />
        <rect x={xH4 + "%"} y={yS + "%"} width={wS + "%"} height={hY + "%"} style={{fill:hashColor}} />
        <rect x={(xH1 - 1) + "%"} y={yS + "%"} width={(wH + 2) + "%"} height={hT + "%"} style={{fill:hashColor}} />
        <rect x={xH2 + "%"} y={yH2 + "%"} width={(xH3 - xH2) + "%"} height={(yH3 - yH2) + "%"} style={{fill:hashColor}} />
        <rect x={(xH1 - 1) + "%"} y={yH4 + "%"} width={(wH + 2) + "%"} height={hB + "%"} style={{fill:hashColor}} />
        <rect x={(xH1 - 1) + "%"} y={yH6 + "%"} width={(wH + 2) + "%"} height={(yE - yH6) + "%"} style={{fill:hashColor}} />

        <line x1={f1xS + "%"} x2={f1xS + "%"} y1={f1yE + "%"} y2={f1yS + "%"} style={{stroke:hashColor, strokeWidth:fLW, strokeLinecap:fLC}} />
        <line x1={f1xS + "%"} x2={f1xT + "%"} y1={f1yS + "%"} y2={f1yS + "%"} style={{stroke:hashColor, strokeWidth:fLW, strokeLinecap:fLC}} />
        <line x1={f1xT + "%"} x2={(f1xT + f1ht) + "%"} y1={f1yS + "%"} y2={(f1yS + f1ht) + "%"} style={{stroke:hashColor, strokeWidth:fLW, strokeLinecap:fLC}} />
        <line x1={f1xT + f1ht + "%"} x2={(f1xE) + "%"} y1={f1yS + f1ht + "%"} y2={(f1yS + f1ht) + "%"} style={{stroke:hashColor, strokeWidth:fLW, strokeLinecap:fLC}} />
        <line x1={f1xE + "%"} x2={(f1xE) + "%"} y1={f1yS + f1ht + "%"} y2={(f1yE) + "%"} style={{stroke:hashColor, strokeWidth:fLW, strokeLinecap:fLC}} />

        <line x1={f2xS + "%"} x2={f2xS + "%"} y1={f2yE + "%"} y2={f2yS + "%"} style={{stroke:hashColor, strokeWidth:fLW, strokeLinecap:fLC}} />
        <line x1={f2xS + "%"} x2={f2xT + "%"} y1={f2yS + "%"} y2={f2yS + "%"} style={{stroke:hashColor, strokeWidth:fLW, strokeLinecap:fLC}} />
        <line x1={f2xT + "%"} x2={(f2xT + f2ht) + "%"} y1={f2yS + "%"} y2={(f2yS + f2ht) + "%"} style={{stroke:hashColor, strokeWidth:fLW, strokeLinecap:fLC}} />
        <line x1={f2xT + f2ht + "%"} x2={(f2xE) + "%"} y1={f2yS + f2ht + "%"} y2={(f2yS + f2ht) + "%"} style={{stroke:hashColor, strokeWidth:fLW, strokeLinecap:fLC}} />
        <line x1={f2xE + "%"} x2={(f2xE) + "%"} y1={f2yS + f2ht + "%"} y2={(f1yS + f1ht) + "%"} style={{stroke:hashColor, strokeWidth:fLW, strokeLinecap:fLC}} />

        {(this.props.p_plusTF) && [
          <LibraryReact.SvgHLine key="h" p_x1p={70} p_x2p={90} p_ycp={80} p_widthP={6} p_color={"#77c"} />,
          <LibraryReact.SvgVLine key="v" p_y1p={70} p_y2p={90} p_xcp={80} p_widthP={6} p_color={"#77c"} />
        ]}
      </svg>
    );
  }
}));


export const SvgUserActivity = inject("UserMobx")(observer(
class SvgUserActivity extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");
    
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const hashColor = "#" + p_color;
    const svgHeightWidth = sizePx + "px";

    const xyCoords0to100ArrayOfArrays1 = [
      [8,49],[10,39],[18,29],[25,25],[33,30],[27,39],[24,49],[8,49]
    ];
    const polygonPointsString1 = JSFUNC.svg_polygon_points_string_from_xy_coords_0to100_array_of_arrays(xyCoords0to100ArrayOfArrays1, sizePx);

    const xyCoords0to100ArrayOfArrays2 = [
      [32,49],[35,38],[40,29],[50,24],[60,29],[65,38],[68,49],[32,49]
    ];
    const polygonPointsString2 = JSFUNC.svg_polygon_points_string_from_xy_coords_0to100_array_of_arrays(xyCoords0to100ArrayOfArrays2, sizePx);

    const xyCoords0to100ArrayOfArrays3 = [
      [92,49],[90,39],[82,29],[75,25],[67,30],[73,39],[76,49],[92,49]
    ];
    const polygonPointsString3 = JSFUNC.svg_polygon_points_string_from_xy_coords_0to100_array_of_arrays(xyCoords0to100ArrayOfArrays3, sizePx);

    const ellipseLineWidth = "3%";
    const ellipseLineCap = "round";

    return(
      <svg height={svgHeightWidth} width={svgHeightWidth}>
        <circle cx="25%" cy="14%" r="8%" fill={hashColor} />
        <circle cx="50%" cy="10%" r="10%" fill={hashColor} />
        <circle cx="75%" cy="14%" r="8%" fill={hashColor} />

        <polygon points={polygonPointsString1} style={{fill:hashColor}} />
        <polygon points={polygonPointsString2} style={{fill:hashColor}} />
        <polygon points={polygonPointsString3} style={{fill:hashColor}} />

        <line x1="8%" x2="18%" y1="55%" y2="65%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />
        <line x1="18%" x2="40%" y1="65%" y2="68%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />
        <line x1="40%" x2="50%" y1="68%" y2="69%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />
        <line x1="50%" x2="60%" y1="69%" y2="68%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />
        <line x1="60%" x2="82%" y1="68%" y2="65%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />
        <line x1="82%" x2="92%" y1="65%" y2="55%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />

        <line x1="34%" x2="36%" y1="55%" y2="76%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />
        <line x1="36%" x2="43%" y1="76%" y2="91%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />
        <line x1="43%" x2="50%" y1="91%" y2="95%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />
        <line x1="50%" x2="57%" y1="95%" y2="91%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />
        <line x1="57%" x2="64%" y1="91%" y2="76%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />
        <line x1="64%" x2="66%" y1="76%" y2="55%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />

        <line x1="8%" x2="12%" y1="55%" y2="73%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />
        <line x1="12%" x2="23%" y1="73%" y2="87%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />
        <line x1="23%" x2="50%" y1="87%" y2="95%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />
        <line x1="50%" x2="77%" y1="95%" y2="87%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />
        <line x1="77%" x2="88%" y1="87%" y2="73%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />
        <line x1="88%" x2="92%" y1="73%" y2="55%" style={{stroke:hashColor, strokeWidth:ellipseLineWidth, strokeLinecap:ellipseLineCap}} />
      </svg>
    );
  }
}));


export const SvgCaptureImport = inject("UserMobx")(observer(
class SvgCaptureImport extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");
    
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const hashColor = "#" + p_color;
    const svgHeightWidth = sizePx + "px";

    const binLineWidth = "5%";
    const arrowLineWidth = "13%";
    const binLineCap = "round";
    const arrowLineCap = "round";

    const frontToBackX = 15;
    const frontToDipX = 30;
    const frontToHoleX = 32;

    const x1 = 3;
    const x2 = x1 + frontToBackX;
    const x3 = x1 + frontToDipX;
    const x4 = x1 + frontToHoleX;
    const x8 = 97;
    const x7 = x8 - frontToBackX;
    const x6 = x8 - frontToDipX;
    const x5 = x8 - frontToHoleX;

    const y1 = 97; //bin bottom
    const y2 = 77; //front dip bottom
    const y3 = 67; //front top
    const y4 = 35; //bin back top

    const arrowCenterToEdgeX = 17;

    const ax1 = 50 - arrowCenterToEdgeX;
    const ax2 = 50;
    const ax3 = 50 + arrowCenterToEdgeX;

    const ay1 = 60;
    const ay2 = 45;
    const ay3 = 3;

    return(
      <svg height={svgHeightWidth} width={svgHeightWidth}>
        <line x1={x1 + "%"} x2={x1 + "%"} y1={y1 + "%"} y2={y3 + "%"} style={{stroke:hashColor, strokeWidth:binLineWidth, strokeLinecap:binLineCap}} />
        <line x1={x1 + "%"} x2={x3 + "%"} y1={y3 + "%"} y2={y3 + "%"} style={{stroke:hashColor, strokeWidth:binLineWidth, strokeLinecap:binLineCap}} />
        <line x1={x3 + "%"} x2={x3 + "%"} y1={y3 + "%"} y2={y2 + "%"} style={{stroke:hashColor, strokeWidth:binLineWidth, strokeLinecap:binLineCap}} />
        <line x1={x3 + "%"} x2={x6 + "%"} y1={y2 + "%"} y2={y2 + "%"} style={{stroke:hashColor, strokeWidth:binLineWidth, strokeLinecap:binLineCap}} />
        <line x1={x6 + "%"} x2={x6 + "%"} y1={y2 + "%"} y2={y3 + "%"} style={{stroke:hashColor, strokeWidth:binLineWidth, strokeLinecap:binLineCap}} />
        <line x1={x6 + "%"} x2={x8 + "%"} y1={y3 + "%"} y2={y3 + "%"} style={{stroke:hashColor, strokeWidth:binLineWidth, strokeLinecap:binLineCap}} />
        <line x1={x8 + "%"} x2={x8 + "%"} y1={y3 + "%"} y2={y1 + "%"} style={{stroke:hashColor, strokeWidth:binLineWidth, strokeLinecap:binLineCap}} />
        <line x1={x8 + "%"} x2={x1 + "%"} y1={y1 + "%"} y2={y1 + "%"} style={{stroke:hashColor, strokeWidth:binLineWidth, strokeLinecap:binLineCap}} />

        <line x1={x1 + "%"} x2={x2 + "%"} y1={y3 + "%"} y2={y4 + "%"} style={{stroke:hashColor, strokeWidth:binLineWidth, strokeLinecap:binLineCap}} />
        <line x1={x2 + "%"} x2={x4 + "%"} y1={y4 + "%"} y2={y4 + "%"} style={{stroke:hashColor, strokeWidth:binLineWidth, strokeLinecap:binLineCap}} />

        <line x1={x5 + "%"} x2={x7 + "%"} y1={y4 + "%"} y2={y4 + "%"} style={{stroke:hashColor, strokeWidth:binLineWidth, strokeLinecap:binLineCap}} />
        <line x1={x7 + "%"} x2={x8 + "%"} y1={y4 + "%"} y2={y3 + "%"} style={{stroke:hashColor, strokeWidth:binLineWidth, strokeLinecap:binLineCap}} />

        <line x1={ax2 + "%"} x2={ax2 + "%"} y1={ay3 + "%"} y2={ay1 + "%"} style={{stroke:hashColor, strokeWidth:arrowLineWidth, strokeLinecap:arrowLineCap}} />
        <line x1={ax2 + "%"} x2={ax1 + "%"} y1={ay1 + "%"} y2={ay2 + "%"} style={{stroke:hashColor, strokeWidth:arrowLineWidth, strokeLinecap:arrowLineCap}} />
        <line x1={ax2 + "%"} x2={ax3 + "%"} y1={ay1 + "%"} y2={ay2 + "%"} style={{stroke:hashColor, strokeWidth:arrowLineWidth, strokeLinecap:arrowLineCap}} />
      </svg>
    );
  }
}));


export const SvgWrench = inject("UserMobx")(observer(
class SvgWrench extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");
    
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const hashColor = "#" + p_color;
    const svgHeightWidth = sizePx + "px";

    const xyCoords0to100ArrayOfArrays = [
      [12,3],[24,11],[25,16],[23,22],[18,27],
      [12,26],[2,21],[2,27],[6,35],[15,42],
      [19,43],[28,42],[32,45],[78,96],[84,98],
      [89,97],[94,94],[97,89],[98,85],[97,80],
      [94,76],[43,31],[41,28],[41,15],[40,11],
      [37,7],[33,4],[28,2],[21,1]
    ];
    const polygonPointsString = JSFUNC.svg_polygon_points_string_from_xy_coords_0to100_array_of_arrays(xyCoords0to100ArrayOfArrays, sizePx);

    return(
      <svg height={svgHeightWidth} width={svgHeightWidth}>
        <polygon points={polygonPointsString} style={{fill:hashColor}} />
      </svg>
    );
  }
}));

export const SvgExecutiveManagement = inject("UserMobx")(observer(
class SvgExecutiveManagement extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");
    
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const heightPx = Math.round(sizePx);
    const widthPx = Math.round(sizePx);
    const hashColor = "#" + p_color;

    const pieRadius = 25;

    const barHeightsArray = [7, 10, 18, 25, 45, 40, 70];
    const numBars = barHeightsArray.length;
    const barLeftToBarLeftWidth0to100 = (96 / numBars);
    const barWidth0to100 = (barLeftToBarLeftWidth0to100 - 1);
    const halfBarWidth0to100 = (barWidth0to100 / 2);
    var barLeftsArray = [];
    var barCentersArray = [];
    for(let b = 0; b < numBars; b++) {
      var barLeft = (2 + (b * barLeftToBarLeftWidth0to100));
      barLeftsArray.push(barLeft);
      barCentersArray.push(barLeft + halfBarWidth0to100);
    }

    return(
      <svg height={heightPx + "px"} width={widthPx + "px"} viewBox="0 0 100 100">
        <LibraryReact.CircleGraphSegment0to180deg p_radius0to100={pieRadius} p_angleDeg={180} p_rotationDeg={0} p_color={p_color} />
        <LibraryReact.CircleGraphSegment0to180deg p_radius0to100={pieRadius} p_angleDeg={135} p_rotationDeg={90} p_color={p_color} />
        <LibraryReact.CircleGraphSegment0to180deg p_radius0to100={pieRadius - 2} p_angleDeg={90} p_rotationDeg={225} p_color={p_color} />
        <LibraryReact.CircleGraphSegment0to180deg p_radius0to100={pieRadius - 2} p_angleDeg={42} p_rotationDeg={320} p_color={p_color} />
        {barHeightsArray.map((m_barHeight, m_index) =>
          <React.Fragment key={m_barHeight}>
            <rect x={barLeftsArray[m_index]} y={(100 - m_barHeight)} width={barWidth0to100} height={m_barHeight} style={{fill:hashColor}} />
            {(m_index > 0) &&
              <line x1={barCentersArray[m_index]} x2={barCentersArray[m_index - 1]} y1={(85 - barHeightsArray[m_index])} y2={(85 - barHeightsArray[m_index - 1])} style={{stroke:hashColor, strokeWidth:"0.5em"}} />
            }
          </React.Fragment>
        )}
      </svg>
    );
  }
}));


export const SvgToDo = inject("UserMobx")(observer(
class SvgToDo extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");
    
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const hashColor = "#" + p_color;

    const heightPx = Math.round(sizePx);
    const widthPx = Math.round(sizePx);

    const svgHeight = heightPx + "px";
    const svgWidth = widthPx + "px";

    const boardWidth = 70;
    const clipboardHeight = 95;
    const clipWidth = 30;
    const clipHeight = 15;
    const cbLW = 2.5;
    const cbLC = "round";

    const x1 = 50 - (boardWidth / 2);
    const x4 = 50 + (boardWidth / 2);
    const x2 = 50 - (clipWidth / 2);
    const x3 = 50 + (clipWidth / 2);

    const y1 = 50 - (clipboardHeight / 2);
    const y4 = 50 + (clipboardHeight / 2);
    const y2 = y1 + (clipHeight / 2);
    const y3 = y1 + clipHeight;

    const lx1 = 35;
    const lx2 = 75;
    const ly1 = 35;
    const lySpace = 12;
    const lLW = 1.2;

    return(
      <svg height={svgHeight} width={svgWidth}>
        <line x1={x1 + "%"} x2={x1 + "%"} y1={y4 + "%"} y2={y2 + "%"} style={{stroke:hashColor, strokeWidth:cbLW, strokeLinecap:cbLC}} />
        <line x1={x1 + "%"} x2={x2 + "%"} y1={y2 + "%"} y2={y2 + "%"} style={{stroke:hashColor, strokeWidth:cbLW, strokeLinecap:cbLC}} />
        <line x1={x2 + "%"} x2={x2 + "%"} y1={y1 + "%"} y2={y3 + "%"} style={{stroke:hashColor, strokeWidth:cbLW, strokeLinecap:cbLC}} />
        <line x1={x2 + "%"} x2={x3 + "%"} y1={y1 + "%"} y2={y1 + "%"} style={{stroke:hashColor, strokeWidth:cbLW, strokeLinecap:cbLC}} />
        <line x1={x2 + "%"} x2={x3 + "%"} y1={y3 + "%"} y2={y3 + "%"} style={{stroke:hashColor, strokeWidth:cbLW, strokeLinecap:cbLC}} />
        <line x1={x3 + "%"} x2={x3 + "%"} y1={y1 + "%"} y2={y3 + "%"} style={{stroke:hashColor, strokeWidth:cbLW, strokeLinecap:cbLC}} />
        <line x1={x3 + "%"} x2={x4 + "%"} y1={y2 + "%"} y2={y2 + "%"} style={{stroke:hashColor, strokeWidth:cbLW, strokeLinecap:cbLC}} />
        <line x1={x4 + "%"} x2={x4 + "%"} y1={y2 + "%"} y2={y4 + "%"} style={{stroke:hashColor, strokeWidth:cbLW, strokeLinecap:cbLC}} />
        <line x1={x1 + "%"} x2={x4 + "%"} y1={y4 + "%"} y2={y4 + "%"} style={{stroke:hashColor, strokeWidth:cbLW, strokeLinecap:cbLC}} />

        <line x1={lx1 + "%"} x2={lx2 + "%"} y1={ly1 + "%"} y2={ly1 + "%"} style={{stroke:hashColor, strokeWidth:lLW, strokeLinecap:cbLC}} />
        <line x1={lx1 + "%"} x2={lx2 + "%"} y1={(ly1 + (1 * lySpace)) + "%"} y2={(ly1 + (1 * lySpace)) + "%"} style={{stroke:hashColor, strokeWidth:lLW, strokeLinecap:cbLC}} />
        <line x1={lx1 + "%"} x2={lx2 + "%"} y1={(ly1 + (2 * lySpace)) + "%"} y2={(ly1 + (2 * lySpace)) + "%"} style={{stroke:hashColor, strokeWidth:lLW, strokeLinecap:cbLC}} />
      </svg>
    );
  }
}));

export const SvgWorkload = inject("UserMobx")(observer(
class SvgWorkload extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");
    
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const hashColor = "#" + p_color;

    const heightPx = Math.round(sizePx);
    const widthPx = Math.round(sizePx);

    const svgHeight = heightPx + "px";
    const svgWidth = widthPx + "px";


    const x1 = 10;
    const x2 = 60;
    const x3 = 95;
    const y1 = 27;
    const y2 = 60;
    const y3 = 95;
    const calendarLW = 2;
    const calendarLC = "round";

    const clockX = 27;
    const clockY = 32;
    const clockR = 25;
    const clockLW = 3;

    const minX = clockX;
    const minY = clockY - (clockR * 0.9);
    const hourX = clockX + (clockR * 0.25);
    const hourY = clockY + (clockR * 0.3);

    return(
      <svg height={svgHeight} width={svgWidth}>
        <line x1={x1 + "%"} x2={x1 + "%"} y1={y2 + "%"} y2={y3 + "%"} style={{stroke:hashColor, strokeWidth:calendarLW, strokeLinecap:calendarLC}} />
        <line x1={x1 + "%"} x2={x3 + "%"} y1={y3 + "%"} y2={y3 + "%"} style={{stroke:hashColor, strokeWidth:calendarLW, strokeLinecap:calendarLC}} />
        <line x1={x3 + "%"} x2={x3 + "%"} y1={y1 + "%"} y2={y3 + "%"} style={{stroke:hashColor, strokeWidth:calendarLW, strokeLinecap:calendarLC}} />
        <line x1={x2 + "%"} x2={x3 + "%"} y1={y1 + "%"} y2={y1 + "%"} style={{stroke:hashColor, strokeWidth:(calendarLW), strokeLinecap:calendarLC}} />

        <circle cx={clockX + "%"} cy={clockY + "%"} r={clockR + "%"} fill="none" style={{stroke:hashColor, strokeWidth:clockLW}} />
        <line x1={clockX + "%"} x2={minX + "%"} y1={minY + "%"} y2={clockY + "%"} style={{stroke:hashColor, strokeWidth:clockLW, strokeLinecap:calendarLC}} />
        <line x1={clockX + "%"} x2={hourX + "%"} y1={clockY + "%"} y2={hourY + "%"} style={{stroke:hashColor, strokeWidth:clockLW, strokeLinecap:calendarLC}} />

        {[0,1,2].map((m_col) =>
          [0,1].map((m_row) =>
            ((m_col > 0) || (m_row > 0)) &&
            <rect key={"c" + m_col + "r" + m_row} x={(29 + (m_col * 20)) + "%"} y={(47 + (m_row * 20)) + "%"} width="12%" height="12%" style={{fill:hashColor}} />
          )
        )}
      </svg>
    );
  }
}));



export const SvgMetrics = inject("UserMobx")(observer(
class SvgMetrics extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");
    
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const heightPx = Math.round(sizePx);
    const widthPx = Math.round(sizePx);
    const hashColor = "#" + p_color;

    const bLW = 1; //box line width
    const boxLC = "round"; //box linecap
    const b1XC = 17; //box 1 X center
    const b2XC = (100 - b1XC); //box 1 X center
    const bYC = 50; //both boxes Y center
    const bH = 22; //box height
    const bW = bH; //box width
    const hBH = (bH / 2);
    const hBW = (bW / 2);
    const chLW = 2; //check line width
    const chLC = "round"; //check linecap
    const chSLX = (bW * 0.35); //check short stick length in X
    const chSLY = chSLX; //check short stick length in Y
    const chLLX = (bW * 0.7); //check long stick length in X
    const chLLY = (bW * 1.2); //check long stick length in Y

    return(
      <svg height={heightPx + "px"} width={widthPx + "px"}>
        {[b1XC, b2XC].map((m_xC) =>
          <>
            <line x1={(m_xC - hBW) + "%"} x2={(m_xC - hBW) + "%"} y1={(bYC - hBH) + "%"} y2={(bYC + hBH) + "%"} style={{stroke:hashColor, strokeWidth:bLW, strokeLinecap:boxLC}} />
            <line x1={(m_xC - hBW) + "%"} x2={(m_xC + hBW) + "%"} y1={(bYC + hBH) + "%"} y2={(bYC + hBH) + "%"} style={{stroke:hashColor, strokeWidth:bLW, strokeLinecap:boxLC}} />
            <line x1={(m_xC + hBW) + "%"} x2={(m_xC + hBW) + "%"} y1={(bYC + hBH) + "%"} y2={(bYC - hBH) + "%"} style={{stroke:hashColor, strokeWidth:bLW, strokeLinecap:boxLC}} />
            <line x1={(m_xC + hBW) + "%"} x2={(m_xC - hBW) + "%"} y1={(bYC - hBH) + "%"} y2={(bYC - hBH) + "%"} style={{stroke:hashColor, strokeWidth:bLW, strokeLinecap:boxLC}} />
            
            <line x1={(m_xC) + "%"} x2={(m_xC - chSLX) + "%"} y1={(bYC) + "%"} y2={(bYC - chSLY) + "%"} style={{stroke:hashColor, strokeWidth:chLW, strokeLinecap:chLC}} />
            <line x1={(m_xC) + "%"} x2={(m_xC + chLLX) + "%"} y1={(bYC) + "%"} y2={(bYC - chLLY) + "%"} style={{stroke:hashColor, strokeWidth:chLW, strokeLinecap:chLC}} />
          </>
        )}

        <line x1={(36) + "%"} x2={(42) + "%"} y1={(bYC) + "%"} y2={(bYC) + "%"} style={{stroke:hashColor, strokeWidth:bLW, strokeLinecap:boxLC}} />
        <line x1={(48) + "%"} x2={(54) + "%"} y1={(bYC) + "%"} y2={(bYC) + "%"} style={{stroke:hashColor, strokeWidth:bLW, strokeLinecap:boxLC}} />
        <line x1={(60) + "%"} x2={(66) + "%"} y1={(bYC) + "%"} y2={(bYC) + "%"} style={{stroke:hashColor, strokeWidth:bLW, strokeLinecap:boxLC}} />
      </svg>
    );
  }
}));



export const SvgOpenCapture = inject("UserMobx")(observer(
class SvgOpenCapture extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 1);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = Math.round(p_sizeEm * c_userFontSizePx);
    const svgHeightWidth = sizePx + "px";
    const hashColor = "#" + p_color;

    const outer4CurlsLC = "round";
    const rectHeight0to100 = 55;
    const rectLW = "5%";
    const arrowLW = "12%";

    const rectCenterX = 36;
    const rectCenterY = (100 - rectCenterX);
    const rectX = (rectCenterX - (rectHeight0to100 / 2));
    const rectY = (rectCenterY - (rectHeight0to100 / 2));
    const rectRadius = 4;

    const arrowBaseX = rectCenterX;
    const arrowBaseY = rectCenterY;
    const arrowTipX = 90;
    const arrowTipY = 10;
    const arrowLeftEndX = 65;
    const arrowLeftEndY = 15;
    const arrowRightEndX = (arrowTipX - (arrowLeftEndY - arrowTipY));
    const arrowRightEndY = (arrowTipY + (arrowTipX - arrowLeftEndX));

    return(
      <svg height={svgHeightWidth} width={svgHeightWidth}>
        <rect x={rectX + "%"} y={rectY + "%"} rx={rectRadius + "%"} ry={rectRadius + "%"} width={rectHeight0to100 + "%"} height={rectHeight0to100 + "%"} style={{stroke:hashColor, strokeWidth:rectLW, strokeLinecap:outer4CurlsLC, fill:"transparent"}} />
        <line x1={arrowBaseX + "%"} x2={arrowTipX + "%"} y1={arrowBaseY + "%"} y2={arrowTipY + "%"} style={{stroke:hashColor, strokeWidth:arrowLW, strokeLinecap:outer4CurlsLC}} />
        <line x1={arrowTipX + "%"} x2={arrowLeftEndX + "%"} y1={arrowTipY + "%"} y2={arrowLeftEndY + "%"} style={{stroke:hashColor, strokeWidth:arrowLW, strokeLinecap:outer4CurlsLC}} />
        <line x1={arrowTipX + "%"} x2={arrowRightEndX + "%"} y1={arrowTipY + "%"} y2={arrowRightEndY + "%"} style={{stroke:hashColor, strokeWidth:arrowLW, strokeLinecap:outer4CurlsLC}} />
      </svg>
    );
  }
}));


export const SvgDownloadIcon = inject("UserMobx")(observer(
class SvgDownloadIcon extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");
    
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const hashColor = "#" + p_color;

    const heightPx = Math.round(sizePx);
    const widthPx = Math.round(sizePx);

    const lineWidth = "10%";
    const lineCap = "round";

    return(
      <svg height={heightPx + "px"} width={widthPx + "px"}>
        <line x1="50%" x2="50%" y1="10%" y2="30%" style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:lineCap}} />
        <line x1="20%" x2="50%" y1="30%" y2="60%" style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:lineCap}} />
        <line x1="50%" x2="80%" y1="60%" y2="30%" style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:lineCap}} />
        <line x1="5%" x2="5%" y1="70%" y2="90%" style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:lineCap}} />
        <line x1="5%" x2="95%" y1="90%" y2="90%" style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:lineCap}} />
        <line x1="95%" x2="95%" y1="70%" y2="90%" style={{stroke:hashColor, strokeWidth:lineWidth, strokeLinecap:lineCap}} />
      </svg>
    );
  }
}));

export const SvgTriangleWithNumber = inject("UserMobx")(observer(
class SvgTriangleWithNumber extends Component { //p_sizeEm, p_color, p_number
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");
    const p_number = this.props.p_number;
    
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const hashColor = "#" + p_color;
    const number1Decimal = JSFUNC.number_to_fixed_decimals(p_number, 1);

    const heightPx = Math.round(sizePx);
    const widthPx = Math.round(sizePx * 1.5);

    var bgColor = hashColor;
    var fontColor = "#333";
    var numberDisplay = number1Decimal;
    var textX = (0.3 * widthPx);
    if(p_number === -1) {
      bgColor = "#ddd";
      fontColor = "#777";
      numberDisplay = "N/A";
      textX = textX = (0.27 * widthPx);
    }

    const xl = (0.05 * widthPx);
    const xc = (0.5 * widthPx);
    const xr = (0.95 * widthPx);
    const yb = (0.95 * heightPx);
    const yt = (0.05 * heightPx);
    const bgPolyPoints = xl + "," + yb + " " + xc + "," + yt + " " + xr + "," + yb + " " + xl + "," + yb;
    const edgeColor = "#aaa";

    const textY = (0.83 * heightPx);
    const textFontSize = (p_sizeEm * 0.4) + "em";

    return(
      <svg width={widthPx + "px"} height={heightPx + "px"}>
        <polygon points={bgPolyPoints} style={{fill:bgColor, stroke:edgeColor, strokeWidth:"1"}} />
        <text x={textX + "px"} y={textY + "px"} fill={fontColor} style={{fontSize:textFontSize, fontWeight:"bold"}}>
          {numberDisplay}
        </text>
      </svg>
    );
  }
}));


export const SvgFavoriteIcon = inject("UserMobx")(observer(
class SvgFavoriteIcon extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 1);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const betweenScale0to1 = 0.5;
    const rgbDecimalAdd = -30;
    
    const sizePx = Math.round(p_sizeEm * c_userFontSizePx);

    //XY of 5 points on a circle starting at the top and going clockwise
    const starTipsCircleXY0to1ArraysObj = JSFUNC.calculate_circle_points_xy_0to1_arrays_obj(90, 72, false, 6, 4);
    const starTipsX0to1Array = starTipsCircleXY0to1ArraysObj.x0to1Array; //[0, 0.9511, 0.5878, -0.5878, -0.9511, 0]
    const starTipsY0to1Array = starTipsCircleXY0to1ArraysObj.y0to1Array; //[1, 0.309, -0.809, -0.809, 0.309, 1]

    //XY of 5 points between the main 5 points (rotated 36 degrees)
    const betweenCircleXY0to1ArraysObj = JSFUNC.calculate_circle_points_xy_0to1_arrays_obj((90-36), 72, false, 5, 4);
    const betweenX0to1Array = betweenCircleXY0to1ArraysObj.x0to1Array; //[0.5878, 0.9511, 0, -0.9511, -0.5878]
    const betweenY0to1Array = betweenCircleXY0to1ArraysObj.y0to1Array; //[0.809, -0.309, -1, -0.309, 0.809]

    var starXYCoords0to100ArrayOfArrays = [];
    for(let p = 0; p <= 5; p++) {
      var starTipX0to100 = ((starTipsX0to1Array[p] * 50) + 50);
      var starTipY0to100 = (50 - (starTipsY0to1Array[p] * 50));
      starXYCoords0to100ArrayOfArrays.push([starTipX0to100, starTipY0to100]);
      if(p <= 4) {
        var betweenX0to100 = (((betweenX0to1Array[p] * betweenScale0to1) * 50) + 50);
        var betweenY0to100 = (50 - ((betweenY0to1Array[p] * betweenScale0to1) * 50));
        starXYCoords0to100ArrayOfArrays.push([betweenX0to100, betweenY0to100]);
      }
    }
    const starPolygonPointsString = JSFUNC.svg_polygon_points_string_from_xy_coords_0to100_array_of_arrays(starXYCoords0to100ArrayOfArrays, sizePx);

    const darkColor = JSFUNC.color_add_int_rgb_values(p_color, rgbDecimalAdd, rgbDecimalAdd, rgbDecimalAdd, false);

    const svgRadialGradientDefPolygonUniqueFillUrlID = "starRadialGradientFillUrlID" + p_color;

    return(
      <svg height={sizePx + "px"} width={sizePx + "px"}>
        <defs>
          <radialGradient id={svgRadialGradientDefPolygonUniqueFillUrlID} cx="0.8" cy="0.8" r="0.6">
            <stop offset="10%" stopColor={"#" + darkColor} />
            <stop offset="90%" stopColor={"#" + p_color} />
          </radialGradient>
        </defs>
        <polygon points={starPolygonPointsString} style={{stroke:"#bbbbbb", strokeWidth:"0.1em", fill:"url(#" + svgRadialGradientDefPolygonUniqueFillUrlID + ")"}} />
      </svg>
    );
  }
}));



export const SvgEyeIcon = inject("UserMobx")(observer(
class SvgEyeIcon extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);
    const hashColor = "#" + p_color;

    const heightPx = Math.round(sizePx);
    const widthPx = Math.round(sizePx);
    const svgHeight = heightPx + "px";
    const svgWidth = widthPx + "px";

    const eyeCenterX = 50;
    const eyeCenterY = 50;
    const eyeRadiusX = 45;
    const eyeRadiusY = 23;
    const pupilRadius = 12;
    const eyeStrokeWidth = "0.1em";
    const eyeStrokeLinecap = "round";
    const pupilStrokeWidth = "0.1em";
    const pupilStrokeLinecap = "round";

    return(
      <svg height={svgHeight} width={svgWidth}>
        <ellipse cx={eyeCenterX + "%"} cy={eyeCenterY + "%"} rx={eyeRadiusX + "%"} ry={eyeRadiusY + "%"} style={{stroke:hashColor, strokeWidth:eyeStrokeWidth, strokeLinecap:eyeStrokeLinecap, fill:"none"}} />
        <circle cx={eyeCenterX + "%"} cy={eyeCenterY + "%"} r={pupilRadius + "%"} style={{stroke:hashColor, strokeWidth:pupilStrokeWidth, strokeLinecap:pupilStrokeLinecap, fill:hashColor}} />
      </svg>
    );
  }
}));

export const SvgEyeWithSlashIcon = inject("UserMobx")(observer(
class SvgEyeWithSlashIcon extends Component { //p_sizeEm, p_color
  render() {
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2);
    const p_color = JSFUNC.prop_value(this.props.p_color, "999999");

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const sizePx = (p_sizeEm * c_userFontSizePx);

    const hashColor = "#" + p_color;

    const heightPx = Math.round(sizePx);
    const widthPx = Math.round(sizePx);
    const svgHeight = heightPx + "px";
    const svgWidth = widthPx + "px";

    const eyeCenterX = 50;
    const eyeCenterY = 50;
    const eyeRadiusX = 45;
    const eyeRadiusY = 23;
    const eyeStrokeWidth = "0.1em";
    const eyeStrokeLinecap = "round";
    const slashStrokeWidth = "0.1em";
    const slashStrokeLinecap = "round";

    return(
      <svg height={svgHeight} width={svgWidth}>
        <ellipse cx={eyeCenterX + "%"} cy={eyeCenterY + "%"} rx={eyeRadiusX + "%"} ry={eyeRadiusY + "%"} style={{stroke:hashColor, strokeWidth:eyeStrokeWidth, strokeLinecap:eyeStrokeLinecap, fill:"none"}} />
        <line x1="20%" y1="20%" x2="80%" y2="80%" style={{stroke:hashColor, strokeWidth:slashStrokeWidth, strokeLinecap:slashStrokeLinecap}} />
      </svg>
    );
  }
}));
